export const HEADLINES_MESSAGE_COUNT = 50;
